import { CheckoutState } from '../../state';
import { PaypalScriptStatus } from '../../state/paypal';
import {
    areAsyncExpressCheckoutEligibleCommonRulesMet,
    isPaypalAvailableAsExpressPaymentMethod,
} from '../expressCheckoutConditions';
import { getPaypalScriptStatus } from './pureSelectors';

export const areAsyncExpressPaypalEligibleRulesMet = (state: CheckoutState) =>
    areAsyncExpressCheckoutEligibleCommonRulesMet(state) &&
    isPaypalAvailableAsExpressPaymentMethod(state) &&
    getPaypalScriptStatus(state) !== PaypalScriptStatus.failed;
